import {
  getPartners as getPartnersApi,
  getPartner as getPartnerApi,
  createPartner as createPartnerApi,
  updatePartner as updatePartnerApi,
  updatePartnerStatus as updatePartnerStatusApi,
  getPartnerCompanies as getPartnerCompaniesApi,
  assignCompany as assignCompanyApi,
  unassignCompany as unassignCompanyApi,
  getPartnerActionLogs as getPartnerActionLogsApi,
  reassignCompanies as reassignCompaniesApi,
} from "app/api/partners.api";
import {
  getUsers as getUsersApi,
  createUser as createUserApi,
  updateUser as updateUserApi,
  updateUserStatus as updateUserStatusApi,
  regenerateInvite as regenerateInviteApi,
} from "app/api/users.api";
import { setPartners, setCurrentPartner, setPartnerCompanies, setCompaniesLoading, setPartnerUsers, setPartnerLogs, setLogsLoading, setLoading, setError } from "./partners.slice";

export const fetchPartners = (params) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await getPartnersApi(params);
    dispatch(setPartners(response.data.data));
  } catch (error) {
    dispatch(setError(error.response?.data?.message || "Failed to fetch partners"));
  }
};

export const fetchPartner = (uuid) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await getPartnerApi(uuid);
    dispatch(setCurrentPartner(response.data.data));
  } catch (error) {
    dispatch(setError(error.response?.data?.message || "Failed to fetch partner"));
  }
};

export const addPartner = (data) => async (dispatch) => {
  try {
    const response = await createPartnerApi(data);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to create partner" };
  }
};

export const editPartner = (uuid, data) => async (dispatch) => {
  try {
    const response = await updatePartnerApi(uuid, data);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to update partner" };
  }
};

export const changePartnerStatus = (uuid, status) => async (dispatch) => {
  try {
    await updatePartnerStatusApi(uuid, { status });
    return { success: true };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to update status" };
  }
};

export const fetchPartnerCompanies = (uuid, params) => async (dispatch) => {
  dispatch(setCompaniesLoading(true));
  try {
    const response = await getPartnerCompaniesApi(uuid, params);
    const payload = response.data.data;
    // Paginator envelope { data, total }; a bare array (older backend) is one page.
    const rows = Array.isArray(payload) ? payload : payload?.data || [];
    const total = Array.isArray(payload) ? payload.length : payload?.total || 0;
    dispatch(setPartnerCompanies({ rows, total }));
  } catch (error) {
    dispatch(setError(error.response?.data?.message || "Failed to fetch companies"));
    dispatch(setCompaniesLoading(false));
  }
};

export const addCompanyToPartner = (uuid, data) => async (dispatch) => {
  try {
    const response = await assignCompanyApi(uuid, data);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to assign company" };
  }
};

export const reassignPartnerCompanies = (uuid, data) => async (dispatch) => {
  try {
    const response = await reassignCompaniesApi(uuid, data);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to reassign companies" };
  }
};

export const removeCompanyFromPartner = (uuid, assignmentId) => async (dispatch) => {
  try {
    await unassignCompanyApi(uuid, assignmentId);
    return { success: true };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to unassign company" };
  }
};

export const fetchPartnerActionLogs = (uuid, params) => async (dispatch) => {
  dispatch(setLogsLoading(true));
  try {
    const response = await getPartnerActionLogsApi(uuid, params);
    const paginated = response.data.data;
    dispatch(setPartnerLogs({
      logs: paginated?.data || [],
      total: paginated?.total || 0,
    }));
  } catch (error) {
    dispatch(setError(error.response?.data?.message || "Failed to fetch action logs"));
    dispatch(setLogsLoading(false));
  }
};

export const fetchPartnerUsers = (partnerId) => async (dispatch) => {
  try {
    const response = await getUsersApi({ partner_id: partnerId, length: 100 });
    dispatch(setPartnerUsers(response.data.data?.data || []));
  } catch (error) {
    dispatch(setError(error.response?.data?.message || "Failed to fetch partner users"));
  }
};

export const addPartnerUser = (data) => async (dispatch) => {
  try {
    const response = await createUserApi(data);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to create user" };
  }
};

export const editPartnerUser = (uuid, data) => async (dispatch) => {
  try {
    const response = await updateUserApi(uuid, data);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to update user" };
  }
};

export const changePartnerUserStatus = (uuid, status) => async (dispatch) => {
  try {
    await updateUserStatusApi(uuid, { status });
    return { success: true };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to update user status" };
  }
};

export const regeneratePartnerUserInvite = (uuid) => async (dispatch) => {
  try {
    const response = await regenerateInviteApi(uuid);
    return { success: true, data: response.data.data };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || "Failed to regenerate invitation" };
  }
};
